import { Divider, Spin } from 'antd'
import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authuser } from '../../store/Authentication/AuthSlice'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import CustomeHeader from '../../components/Admin/Common/CustomeHeader'
import FilterSelect from '../../components/Admin/Common/FilterSelect'
import SimpleTable from '../../components/Admin/Common/SimpleTable'
import ViewButton from '../../components/Admin/Common/ViewButton'
// import KYCView from '../components/KYCVerifications/KYCView'
import PaymentView from '../../components/Admin/PaymentRequest/PaymentView'
import RePaymentView from '../../components/Admin/PaymentRequest/RePaymentView'
import { getFormattedDateTime, get_param_url, toCamelCase } from '../../functions/Utils'
// import { get_kycVerification_list } from '../store/KYC/KYCVerificationSlice'
import { get_payment_request_list, get_repayment_request_list } from '../../store/Admin/PaymentRequest/PaymentRequestSlice'
// import { get_user_list } from '../store/UserManagement/UserManagementSlice'
import { LeftHead, SubHeadContainer, SubHeadTitle, TablePagination, TableTab } from '../../StyledComponents/Common'
import {  ContentContainer, TableTitle, TableTop } from '../../StyledComponents/CreateKeyAccountManager'
import { MainContainer } from '../../StyledComponents/Dashboard'
import { IconImg } from '../../StyledComponents/Header'
// import { DocText, DocTextContainer, SubHeadSection, UserIDContainer, UserText } from '../StyledComponents/KYCVerifications'
import { FilterSection, LabelItem, SpinContainer } from '../../StyledComponents/Queries'
import { TableFilter } from '../../StyledComponents/RateManagement'
import SearchBox from '../../components/Admin/Common/SearchBox'
let debounceTimer= null
function PaymentRequest() {
    const loginedUser = useSelector(authuser);
    const userroles = loginedUser?.userroles;
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const params_payment_id = get_param_url("payment_id")
    const params_repayment_id = get_param_url("repayment_id")
    const [pageType, setPageType] = useState("table");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageRepayment, setCurrentPageRepayment] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [instance, setInstance] = useState({});
    const [data, setData] = useState([]);
    const [getList, setGetList] = useState(false)
    const [repayment_data, setRepaymentData] = useState([]);
    const [loading, setLoading] = useState(true)
    const [tabType, setTabType] = useState("queries");
    const [filter_value, setFilterValue] = useState("All")
    const [filter_value_repayment, setFilterValueRepayment] = useState("All")
    const [filterData, setFilterData] = useState([]);
    const [filterRepaymentData, setFilterRepaymentData] = useState([]);
    const [, setLoad] = useState(false) // [load]
    const handlePageChange = (page) => {
        if(tabType === 'repayments'){
            setCurrentPageRepayment(page);
        }else {
            setCurrentPage(page);
        }
    };
console.log(tabType,params_payment_id,"tabType")
    useEffect(()=> {
        console.log("useeffect23")
        setGetList(false)
        if((params_payment_id || params_repayment_id || tabType) && pageType === 'table'){
            setGetList(true)
        }
        // if(params_payment_id){
        //     setTabType("view_page")

        // }
        
    },[params_payment_id,params_repayment_id,tabType,pageType])

    

    useEffect(()=> {
        if(params_repayment_id != null){
            setTabType("repayments")
        }
        if(params_repayment_id){
            setLoad(true)
            setGetList(true)
            console.log("params_repayment_id",params_repayment_id,data)
            let result = data.filter((i)=> String(i._id) === String(params_repayment_id))
            console.log("result",result)
            if(result.length){
                setLoad(false)
                handleView(result[0])
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[params_repayment_id]
    )
    useEffect(()=>{
        console.log("firstentery")
        if(params_payment_id){
            console.log("useeffectfe")
            // setLoading(true)
            setLoad(true)
            setGetList(true)

            // setTabType("queries")
            console.log("params_payment_id",params_payment_id,data)
            let result = data?.filter((i)=> String(i._id) === String(params_payment_id))
            console.log("result",result)
            if(result.length){
                // setPageType("view_page")
                 setLoad(false)
                handleView(result[0])
            }
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[params_payment_id,getList])

    useEffect(()=>{
        if(pageType === 'table' && getList){
            setInstance({})
            dispatch(get_payment_request_list(''))
            .then(res=>{
                // console.log('login res => ',res);
                if(res?.payload?.data?.statusCode === 200 ){
                    let data = res?.payload?.data?.data
                    if(userroles === 'air_admin' && data.length){
                        data = data.filter((i)=> i.carrier_type === 'Air Cargo')
                    }else if(userroles === 'ocean_admin' && data.length){
                        data = data.filter((i)=> i.carrier_type === 'Ocean Cargo')
                    }
                    if(params_payment_id){
                        let result = data.filter((i)=> String(i.id) === String(params_payment_id))
                        if(result.length){
                            handleView(result[0])
                        }
                    }
                    setData(data)
                    setFilterData(data)
                    // setGetList(false)
                    // setLoading(false)
                }
            })
            .catch(err=>{
                console.error(err);
            })


            dispatch(get_repayment_request_list(''))
            .then(res=>{
                console.log('login res => ',res);
                if(res?.payload?.data?.statusCode === 200 ){
                    let data = res?.payload?.data?.data
                    if(params_repayment_id){
                        let result = data.filter((i)=> String(i.id) === String(params_repayment_id))
                        if(result.length){
                            handleView(result[0])
                        }
                    }
                    console.log ("data",data)
                    setRepaymentData(data)
                    setFilterRepaymentData(data)
                    setGetList(false)
                    setLoading(false)
                }
            })
            .catch(err=>{
                console.error(err);
            })
        }
        // setIsEdit(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[getList])

    const handlePageSizeChange = (current, size) => {
        setPageSize(size);
        if(tabType === 'repayments'){
            setCurrentPageRepayment(1);
        }else {
            setCurrentPage(1);
        }
    };

    const handleView = (record) => {
        setInstance(record)
        setPageType("view_page")
    }

    const handleBack = ()=> {
        setPageType("table")
        navigate(`/payment-request`)
    }

    const handleFilterChange = (value) => {
        if(tabType === 'repayments') {
            setFilterValueRepayment(value)
            let data = filterRepaymentData
            if(value !== 'All'){
                data = filterRepaymentData.filter((i)=> i.payment_status === value)
            }
            setRepaymentData(data)
            setCurrentPageRepayment(1)
        }else {
            setFilterValue(value)
            let data = filterData
            if(value !== 'All'){
                data = filterData.filter((i)=> i.payment_status === value)
            }
            setData(data)
            setCurrentPage(1)
        }
    }


    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'slno',
            render: (text,record,index) => (
                <span>{index + 1}</span>
            ),
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            render: (text,record) => (
                <span>{record?.customer_details?.full_name}</span>
            ),
        },
        {
            title: 'Date of Payment',
            dataIndex: 'created_at',
            render: (text, record,index) => (
                // <span>{getFormattedDateTime(text)}</span>
                        //  console.log(text,record)
                         <span>{getFormattedDateTime(record?.createdAt)}</span>
              ),
        },
        {
            title: 'Amount',
            dataIndex: 'offline_amount',
            render: (text, record,index) => (
                <span>₹ {Number(text).toFixed(2)}</span>
              ),
        },
        {
            title: 'UTR Number',
            dataIndex: 'UTR_number',
        },
        {
            title: 'Status',
            dataIndex: 'payment_status',
            render: (text,record) => (
                <StatusText status={record.payment_status}>{record.payment_status}</StatusText>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (text, record) => (
                <ViewButton handleClick={handleView} data={record} />
              ),
        },
      ];

      const repayment_columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'slno',
            render: (text,record,index) => (
                <span>{index + 1}</span>
            ),
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            render: (text,record) => (
                <span>{record?.customer_details?.full_name}</span>
            ),
        },
        {
            title: 'Date of Payment',
            dataIndex: 'created_at',
            render: (text, record,index) => (
                // console.log(text,record)
                <span>{getFormattedDateTime(record.createdAt)}</span>
              ),
        },
        {
            title: 'Amount',
            dataIndex: 'payment_amount',
            render: (text, record,index) => (
                <span>₹ {Number(record.payment_amount)}</span>
              ),
        },
        {
            title: 'UTR No.',
            dataIndex: 'UTR_number',
        },
        {
            title: 'Status',
            dataIndex: 'payment_status',
            render: (text,record) => (
                <StatusText status={record.payment_status}>{toCamelCase(record.payment_status)}</StatusText>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (text, record) => (
                <ViewButton handleClick={handleView} data={record} />
              ),
        },
      ];
      
    // const repayment_data = [
    //     {
    //         slno: "1",
    //         customer_name: "Devon Lane",
    //         created_at: "2/11/12",
    //         INR_amount: "$4606.27",
    //         payment_status: "Booking Confirmed",
    //     },
    //     {
    //         slno: "2",
    //         customer_name: "Arlene McCoy",
    //         created_at: "4/21/12",
    //         INR_amount: "$8754.08",
    //         payment_status: "Payment Rejected",
    //     },
    //     {
    //         slno: "3",
    //         customer_name: "Darlene Robertson",
    //         created_at: "8/21/15",
    //         INR_amount: "$6340.44",
    //         payment_status: "Waiting for Confirmation",
    //     },
    // ]

    const filter_options = [
        {
            value: 'All',
            label: 'All',
        },
        {
            value: 'Waiting for Confirmation',
            label: 'Waiting for Confirmation',
        },
        {
            value: 'Payment Confirmed',
            label: 'Payment Confirmed',
        },
        {
            value: 'Payment Rejected',
            label: 'Payment Rejected',
        },
        {
            value: 'Refund Completed',
            label: 'Refund Completed',
        },
    ]

    const filter_options_repayments = [
        {
            value: 'All',
            label: 'All',
        },
        {
            value: 'PENDING',
            label: 'PENDING',
        },
        {
            value: 'SUCCESS',
            label: 'SUCCESS',
        },
        {
            value: 'REJECTED',
            label: 'REJECTED',
        },
    ]
        const onSearch = (value)=>{
                let queryStringObj =  {};
                if(value.length < 1)
                    return;
                  if (value?.length > 0) {
                    queryStringObj["search"] = value;
                  }
                let queryString = new URLSearchParams(queryStringObj).toString();
                queryString = queryString ? `?${queryString}` : "";
                if (debounceTimer) clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    if(tabType === 'queries'){
                    dispatch(get_payment_request_list(queryString))
                    .then(res=>{
                        // console.log('login res => ',res);
                        if(res?.payload?.data?.statusCode === 200 ){
                            let data = res?.payload?.data?.data
                            if(userroles === 'air_admin' && data.length){
                                data = data.filter((i)=> i.carrier_type === 'Air Cargo')
                            }else if(userroles === 'ocean_admin' && data.length){
                                data = data.filter((i)=> i.carrier_type === 'Ocean Cargo')
                            }
                            if(params_payment_id){
                                let result = data.filter((i)=> String(i.id) === String(params_payment_id))
                                if(result.length){
                                    handleView(result[0])
                                }
                            }
                            setData(data)
                            setFilterData(data)
                            // setGetList(false)
                            setLoading(false)
                        }
                    })
                    .catch(err=>{
                        console.error(err);
                    })
        
                }
                else {
                    dispatch(get_repayment_request_list(queryString))
                    .then(res=>{
                        console.log('login res => ',res);
                        if(res?.payload?.data?.statusCode === 200 ){
                            let data = res?.payload?.data?.data
                            if(params_repayment_id){
                                let result = data.filter((i)=> String(i.id) === String(params_repayment_id))
                                if(result.length){
                                    handleView(result[0])
                                }
                            }
                            console.log ("data",data)
                            setRepaymentData(data)
                            setFilterRepaymentData(data)
                            setGetList(false)
                            setLoading(false)
                        }
                    })
                    .catch(err=>{
                        console.error(err);
                    })
                }
                }, 700);
            }

            
  return (
    <section className="requestListMain">
        <MainContainer>
        <CustomeHeader title="Payment Request" description="View all payment requests & approve them." />
        {pageType === 'table'? <>
        <div className="mt-4 tableResponsiveASAP">
            <ContentContainer>
                <TableTop>
                    <TableTitle>Request List</TableTitle>
                    <FilterSection className='filter'>
                    <SearchBox onSearch={onSearch}/ >
                        <LabelItem>Filter by</LabelItem>
                        {tabType === 'repayments' ? 
                            <FilterSelect options={filter_options_repayments} width="220px" value={filter_value_repayment} handleChange={handleFilterChange} />
                        : 
                            <FilterSelect options={filter_options} width="220px" value={filter_value} handleChange={handleFilterChange} />
                        }
                    
                    </FilterSection>
                </TableTop>
                <TableFilter>
                    <div className="requestTab">
                        <TableTab className='first sub-tab' active={tabType === 'queries'} onClick={()=> setTabType('queries')}>Queries</TableTab>
                        <Divider type="vertical" />
                        <TableTab className='sub-tab' active={tabType === 'repayments'} onClick={()=> setTabType('repayments')}>Repayments</TableTab>
                    </div>
                </TableFilter>
                {loading? 
                    <SpinContainer className='user-quote'>
                        <Spin />
                    </SpinContainer>:
                    <>
                        {tabType === 'repayments'?
                            <SimpleTable currentPage={currentPageRepayment} pageSize={pageSize} columns={repayment_columns} data={repayment_data} />
                        : 
                            <SimpleTable currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} />
                        }
                    
                    </>
                }
            </ContentContainer>
            {
                tabType === "queries" && data?.length ? 
                    <div className="paginationCustom">
                    <TablePagination
                        style={{ marginTop: 16, textAlign: 'center' }}
                        onChange={handlePageChange}
                        onShowSizeChange={handlePageSizeChange}
                        defaultCurrent={currentPage}
                        defaultPageSize={10}
                        total={data?.length? data.length : 10}
                        showSizeChanger={false}
                        showQuickJumper={false}
                    />
                    </div>
                : null
            }
            {
                tabType === "repayments" &&  repayment_data?.length ?
                <TablePagination
                    style={{ marginTop: 16, textAlign: 'center' }}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange}
                    defaultCurrent={currentPageRepayment}
                    defaultPageSize={10}
                    total={repayment_data?.length? repayment_data.length : 10}
                    showSizeChanger={false}
                    showQuickJumper={false}
                /> : null
            }
        </div>
        </>
            :pageType === 'view_page'? 
            <>
            <ContentContainer>
                    {/* <ContentHead title="User Details"  handleClick={()=> setPageType("table")} /> */}
                    <SubHeadContainer className='flex-column gap-less'>
                        <SubHeadTitle className='sub-head'>Request List</SubHeadTitle>
                        <LeftHead>
                            <IconImg onClick={()=> handleBack()} src={require('../../assets/admin/images/back_page_arrow.png')} />
                            <SubHeadTitle className='sub-title'>User Details</SubHeadTitle>
                        </LeftHead>
                        
                    </SubHeadContainer>
                    {tabType === 'repayments'?
                        <RePaymentView instance={instance} setInstance={setInstance} setPageType={setPageType} />
                    : 
                        <PaymentView instance={instance} setInstance={setInstance} setPageType={setPageType} />
                    }
                            </ContentContainer>
            </>
        : null}
        
        
        </MainContainer>
    </section>
  )
}

export default PaymentRequest

const StatusText = styled.span`
    color: ${({status})=> status === 'Payment Confirmed' || status === 'SUCCESS' ? '#08C004': status === 'Payment Rejected' || status === 'REJECTED'? '#FF3F3B' : status === "Refund Completed"? '#e85856' : status === 'Waiting for Confirmation' || status === 'PENDING'? '#FCBD2C':'#3F4254' };
    font-weight: 700;
`